import TextButton from "@shared/v2/TextButton";

interface DetailsPanelProps {
  className: string;
  error?: string;
}

const FAQ_URL =
  "https://www.brivityknowledge.com/docs/use-connect-services-in-a-transaction#why-dont-i-see-connect-services-in-my-transaction";
const TERMS_OF_SERVICE_URL = "https://connectservices.com/terms-of-service/";

const SHARED_INFO = [
  "Buyer/tenant contact details",
  "Property address and transaction info",
  "Estimated close date",
];

const DetailsPanel = ({ className, error = "" }: DetailsPanelProps) => (
  <div data-cy="connect-services-step-2" className={className}>
    <h1 className="tw-m-0 tw-text-center tw-text-28d tw-font-normal tw-text-gray-75">
      Connect Services Integration
    </h1>

    <div className="tw-text-14d tw-font-normal tw-text-gray-75">
      <p className="tw-m-0">
        This integration automatically connects your clients with free moving support 21 days
        before their estimated close date, giving them time to set up utilities and home services
        without the stress or cost.
      </p>
      <p className="tw-mb-0 tw-mt-[20px]">Information shared with Connect Services:</p>
      <ul className="tw-mb-0 tw-mt-[20px] tw-list-disc tw-pl-[21px]">
        {SHARED_INFO.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      <p className="tw-mb-0 tw-mt-[20px]">
        Clients are under no obligation to sign up for any services, and you can disable this for
        individual transactions in Brivity if needed.
      </p>
    </div>

    {/*
      The error shares the links row rather than adding a flex child. This panel
      already fills 324px of the 328px stage; a block-level error plus its 16px
      gap would be 36px and would clip. See "Deviation D" in the plan.
    */}
    <div className="tw-flex tw-items-center tw-gap-[16px]">
      {/* @ts-expect-error props */}
      <TextButton size="small" onClick={() => window.open(FAQ_URL, "_blank")}>
        Read the FAQ
      </TextButton>
      {/* @ts-expect-error props */}
      <TextButton size="small" onClick={() => window.open(TERMS_OF_SERVICE_URL, "_blank")}>
        Terms of Service
      </TextButton>
      {error && (
        <span
          data-cy="connect-services-activation-error"
          role="alert"
          className="tw-ml-auto tw-text-right tw-text-14d tw-font-normal tw-text-[color:var(--semantic-red-100)]"
        >
          {error}
        </span>
      )}
    </div>
  </div>
);

export default DetailsPanel;
